import * as React from 'react';
import type { SVGProps } from 'react';
const IconSpam = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    data-xds="IconSpam"
    role="presentation"
    {...props}
  >
    <path
      fill="currentColor"
      d="m7.958 1.996 8.258.072 5.788 5.89-.072 8.258-5.89 5.787-8.258-.072-5.787-5.89.072-8.257zm.811 2.007L4.061 8.63l-.057 6.6L8.63 19.94l6.6.057 4.709-4.626.058-6.6L15.37 4.06zM13 15v2h-2v-2zm0-9v7h-2V6z"
    />
  </svg>
);
export default IconSpam;
